import { render, staticRenderFns } from "./AssessmentFarmerQuestions.vue?vue&type=template&id=7f944490&scoped=true"
import script from "./AssessmentFarmerQuestions.vue?vue&type=script&lang=js"
export * from "./AssessmentFarmerQuestions.vue?vue&type=script&lang=js"
import style0 from "./AssessmentFarmerQuestions.vue?vue&type=style&index=0&id=7f944490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f944490",
  null
  
)

export default component.exports